import { connect } from 'react-redux';
import { getCurentUser } from 'Actions/userActions';
import { getInitData } from 'Actions/initActions';
import { getProjectUsages, getUserInvitations } from 'Actions/projectActions';
import { Route, Switch } from 'react-router-dom';
import CloseIcon from '@material-ui/icons/KeyboardArrowLeft';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import React from 'react';

import CreateTicket from './Demand/screens/CETicket';
import InternalSearch from './Demand/screens/InternalSearch';
import Dashboard from './Demand/screens/Dashboard';
import Footer from '../includes/Footer';
import HeaderAuth from '../includes/HeaderAuth';
import MyProjects from './Demand/screens/components/ProjectsSidebar';
import NoMatch from '../NoMatch';
import SealDeal from './Demand/screens/SealDeal';
import ShareProjectDialog from './Demand/screens/components/ShareProjectDialog';
import SidebarTickets from './Demand/screens/components/TicketsSidebar';
import Project from './Demand/screens/Project';
import SingleSlip from './Demand/screens/SingleSlip';
import SingleTicket from './Demand/screens/Ticket';
import Loader from 'Components/Loader';

class DemandHomeRoute extends React.Component {
  state = {
    tabValue: 0,
    shareProjectDialog: false,
    currentProjectId: null,
    currentShareProjectId: null,
    currentTicketId: false,
    sideBarTickets: false,
    openProjectsSidebar: false,
    internal: [],
  };

  componentDidMount() {
    this.props.getProjectUsages();
    this.props.getInitData();
    this.props.getUserInvitations();
  }

  handleProjectsSidebar = () => {
    this.setState({
      openProjectsSidebar: !this.state.openProjectsSidebar,
    });
  };

  handleOpenShareDialog = currentShareProjectId => {
    this.setState({ currentShareProjectId, shareProjectDialog: true });
  };
  handleCloseShareDialog = () => {
    this.setState({
      shareProjectDialog: false,
      // , currentProjectId: null
    });
  };
  setCurrentProjectId = currentProjectId => {
    this.setState({ currentProjectId });
  };
  setCurrentTicketId = currentTicketId => {
    this.setState({ currentTicketId });
  };

  setSugestion = internal => {
    this.setState({ internal });
  };

  renderSidebar = props => {
    if (
      this.props.location.pathname.includes('ticket/create') ||
      this.props.location.pathname.includes('/edit')
    ) {
      return (
        <SidebarTickets
          internal={this.state.internal}
          projectId={this.state.currentProjectId}
        />
      );
    } else {
      return (
        <MyProjects
          handleOpenShareDialog={this.handleOpenShareDialog}
          currentProjectId={this.state.currentProjectId}
          currentTicketId={this.state.currentTicketId}
          notifications={this.props.notifications}
          invitations={this.props.invitations}
        />
      );
    }
  };
  render() {
    if (this.props.isLoading) {
      return <Loader />;
    }
    return (
      <Grid spacing={0} container justify={'space-between'} className="">
        <Grid item xs={12}>
          <Grid
            spacing={0}
            container
            alignItems={'center'}
            justify={'center'}
            className=""
          >
            <Grid item xs={12}>
              <HeaderAuth colored type="logged" />
              {/* {this.renderSubheader()} */}
              {/*<SubHeaderContainer/>*/}
            </Grid>
          </Grid>

          <Grid
            container
            justify={'space-between'}
            className="e-pos-r"
            spacing={0}
            style={{ minHeight: 'calc(100vh - 128px)' }}
          >
            <Grid
              item
              className={
                this.state.openProjectsSidebar
                  ? 'demand-my-projects mobile'
                  : 'demand-my-projects'
              }
            >
              <IconButton
                onClick={this.handleProjectsSidebar}
                className="pull-right u-pad-8 sidebar-close"
              >
                <CloseIcon />
              </IconButton>
              {this.renderSidebar(this.props)}
            </Grid>

            <Switch>
              <Route
                exact
                path={this.props.match.path}
                render={props => (
                  <Dashboard
                    openProjectsSidebar={this.handleProjectsSidebar}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path={`${this.props.match.path}/project/:projectId`}
                render={props => {
                  return (
                    <Project
                      {...props}
                      openProjectsSidebar={this.handleProjectsSidebar}
                      notifications={this.props.notifications}
                      handleOpenShareDialog={this.handleOpenShareDialog}
                      setCurrentProjectId={this.setCurrentProjectId}
                    />
                  );
                }}
              />
              <Route
                exact
                path={`${this.props.match.path}/project/:projectId/ticket/create`}
                render={props => (
                  <CreateTicket
                    notifications={this.props.notifications}
                    handleOpenShareDialog={this.handleOpenShareDialog}
                    setCurrentProjectId={this.setCurrentProjectId}
                    openProjectsSidebar={this.handleProjectsSidebar}
                    setSugestion={this.setSugestion}
                    {...props}
                  />
                )}
              />

              <Route
                exact
                path={`${this.props.match.path}/project/:projectId/ticket/internalSearch`}
                render={props => <InternalSearch {...props} />}
              />

              <Route
                exact
                path={`${this.props.match.path}/project/:projectId/ticket/:ticketId/edit`}
                render={props => (
                  <CreateTicket
                    openProjectsSidebar={this.handleProjectsSidebar}
                    notifications={this.props.notifications}
                    handleOpenShareDialog={this.handleOpenShareDialog}
                    setCurrentProjectId={this.setCurrentProjectId}
                    setSugestion={this.setSugestion}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path={`${this.props.match.path}/project/:projectId/ticket/:ticketId`}
                render={props => (
                  <SingleTicket
                    setCurrentTicketId={this.setCurrentTicketId}
                    setCurrentProjectId={this.setCurrentProjectId}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path={`${this.props.match.path}/project/:projectId/ticket/:ticketId/slips`}
                render={props => (
                  <SealDeal
                    setCurrentTicketId={this.setCurrentTicketId}
                    setCurrentProjectId={this.setCurrentProjectId}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path={`${this.props.match.path}/project/:projectId/ticket/:ticketId/slip/:slipId`}
                render={props => (
                  <SingleSlip
                    setCurrentTicketId={this.setCurrentTicketId}
                    setCurrentProjectId={this.setCurrentProjectId}
                    {...props}
                  />
                )}
              />
              <Route component={NoMatch} />
            </Switch>
          </Grid>
        </Grid>
        <Footer />
        <ShareProjectDialog
          open={this.state.shareProjectDialog}
          handleClose={this.handleCloseShareDialog}
          currentProjectId={this.state.currentShareProjectId}
        />
      </Grid>
    );
  }
}

const mapStateToProps = store => {
  return {
    notifications: store.notifications.notifications,
    invitations: store.projects.userInvitations,
    user: store.user.user,
  };
};
const mapDispatchToProps = dispatch => ({
  getCurentUser: () => {
    dispatch(getCurentUser());
  },
  getProjectUsages: () => {
    dispatch(getProjectUsages());
  },
  getInitData: () => {
    dispatch(getInitData());
  },
  getUserInvitations: () => {
    dispatch(getUserInvitations());
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(DemandHomeRoute);
